export default __webpack_public_path__ + "static/media/map.61ddbe23.svg";